
import React from 'react';
import { CarIcon, BookmarkCheck } from 'lucide-react';
import { useCar } from '@/contexts/CarContext';
import { Card } from '@/components/ui/card';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

interface CarCarouselProps {
  cars: any[];
  selectedCarId: string | null;
  mainCarId: string | null;
  onSelectCar: (carId: string) => void;
}

const CarCarousel: React.FC<CarCarouselProps> = ({
  cars,
  selectedCarId,
  mainCarId,
  onSelectCar,
}) => {
  return (
    <Carousel
      opts={{ 
        align: 'start',
        loop: cars.length > 1
      }}
      className="w-full"
    >
      <CarouselContent>
        {cars.map((car) => (
          <CarouselItem key={car.id} className="basis-full md:basis-1/2 lg:basis-1/3">
            <div className="p-1">
              <Card 
                className={`p-4 cursor-pointer border-2 ${
                  car.id === selectedCarId 
                    ? 'border-lime' 
                    : 'border-transparent'
                }`}
                onClick={() => onSelectCar(car.id)}
              >
                <div className="flex items-center space-x-3 relative">
                  {car.id === mainCarId && (
                    <div className="absolute -top-2 -left-2 bg-lime rounded-full p-1">
                      <BookmarkCheck size={16} className="text-black" /> {/* Reverted to text-black */}
                    </div>
                  )}
                  <div className="flex-shrink-0">
                    <CarIcon className="h-10 w-10 text-soft-blue" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base font-medium truncate">
                      {car.nickname || `${car.brand} ${car.model}`}
                    </h3>
                    {car.nickname && (
                      <p className="text-sm text-gray-500 truncate">
                        {car.brand} {car.model}
                      </p>
                    )}
                  </div>
                </div>
              </Card>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
      {cars.length > 1 && (
        <>
          <CarouselPrevious className="left-1 md:-left-5" />
          <CarouselNext className="right-1 md:-right-5" />
        </>
      )}
    </Carousel>
  );
};

export default CarCarousel;
